import {
  createAsyncThunk,
  createSlice,
} from '@reduxjs/toolkit';

import { apiGet, apiPut, apiDel } from 'app/shared-components/util/restAPI';

export const fetchMeetingTypesByOwner = createAsyncThunk(
  "meetingTypes/fetchMeetingTypesByOwner",
  async ({ownerKey}, { dispatch, getState }) => {
    const apiName = 'CoreAPI3';
    const path = `/x3/meetingtype/byowner/${ownerKey}`;
    const options = {
      headers: {},
      response: false,
    };
    const data = await apiGet(apiName, path, options);
    return { ownerKey, meetingTypes: data };
  }
);

export const createMeetingType = createAsyncThunk(
  "meetingTypes/createMeetingType",
  async (meetingTypeData, { dispatch, getState }) => {
    const apiName = 'CoreAPI3';
    const path = '/x3/meetingtype/';
    const options = {
      body: meetingTypeData,
      headers: {},
      response: false,
    };
    const data = await apiPut(apiName, path, options);
    return data;
  }
);

export const updateMeetingType = createAsyncThunk(
  "meetingTypes/updateMeetingType",
  async ({id, ...meetingTypeData}, { dispatch, getState }) => {
    const apiName = 'CoreAPI3';
    const path = `/x3/meetingtype/${id}`;
    const options = {
      body: meetingTypeData,
      headers: {},
      response: false,
    };
    const data = await apiPut(apiName, path, options);
    return data;
  }
);

export const deleteMeetingType = createAsyncThunk(
  "meetingTypes/deleteMeetingType",
  async (id, { dispatch, getState }) => {
    const apiName = 'CoreAPI3';
    const path = `/x3/meetingtype/${id}`;
    const options = {
      headers: {},
      response: false,
    };
    await apiDel(apiName, path, options);
    return id;
  }
);

const meetingTypesSlice = createSlice({
  name: 'meetingTypes',
  initialState: {
    meetingTypesByOwner: {},
    selectedMeetingTypeId: null,
  },
  reducers: {
    setSelectedMeetingTypeId: (state, action) => {
      state.selectedMeetingTypeId = action.payload;
    },
  },
  extraReducers: builder => {
    builder
    .addCase(fetchMeetingTypesByOwner.fulfilled, (state, action) => {
       state.meetingTypesByOwner[action.payload.ownerKey] = action.payload.meetingTypes;
    })
    .addCase(createMeetingType.fulfilled, (state, action) => {
       const ownerKey = action.payload.ownerId;
       if (state.meetingTypesByOwner[ownerKey]) {
         state.meetingTypesByOwner[ownerKey].push(action.payload);
       }
    })
    .addCase(updateMeetingType.fulfilled, (state, action) => {
       const ownerKey = action.payload.ownerId;
       if (state.meetingTypesByOwner[ownerKey]) {
         const index = state.meetingTypesByOwner[ownerKey].findIndex(mt => mt.id === action.payload.id);
         if (index !== -1) {
           state.meetingTypesByOwner[ownerKey][index] = action.payload;
         }
       }
    })
    .addCase(deleteMeetingType.fulfilled, (state, action) => {
       Object.keys(state.meetingTypesByOwner).forEach(ownerKey => {
         state.meetingTypesByOwner[ownerKey] = state.meetingTypesByOwner[ownerKey].filter(mt => mt.id !== action.payload);
       });
    });
  },
});

export const selectMeetingTypesByOwner = (ownerKey) => ({ meetingTypes }) => 
  meetingTypes.meetingTypesByOwner[ownerKey] || [];

export const selectSelectedMeetingTypeId = ({ meetingTypes }) => meetingTypes.selectedMeetingTypeId;

export const { setSelectedMeetingTypeId } = meetingTypesSlice.actions;

export default meetingTypesSlice.reducer;